"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
// biome-ignore lint: error type
import Error from "next/error";
import { useEffect } from "react";
import { defaultLocale } from "i18n";
export default function GlobalError(props) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== props.error) {
    t0 = () => {
      Sentry.captureException(props.error);
    };
    t1 = [props.error];
    $[0] = props.error;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <html lang={defaultLocale}><body><Error statusCode={undefined as never} /></body></html>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}